import { utils as commonUtils } from '@neo-one/utils';
import { common, InvalidFormatError } from '../../common';
import { addressToScriptHash } from '../../helpers';
import { utils } from '../../utils';
import { AttributeUsageModel, UInt160AttributeModel } from './attribute';
import { TransactionBaseModel } from './TransactionBaseModel';
import { TransactionTypeModel } from './TransactionTypeModel';
export class InvocationTransactionModel extends TransactionBaseModel {
    constructor({ version, attributes, inputs, outputs, scripts, hash, gas, script, }) {
        super({
            version,
            type: TransactionTypeModel.Invocation,
            attributes,
            inputs,
            outputs,
            scripts,
            hash,
        });
        this.gas = gas;
        this.script = script;
        if (this.version > 1) {
            throw new InvalidFormatError(`expected version <= 1, found: ${this.version}`);
        }
        if (this.script.length === 0) {
            throw new InvalidFormatError('expected script');
        }
        if (this.gas.lt(utils.ZERO)) {
            throw new InvalidFormatError(`expected valid gas, found: ${this.gas.toString()}`);
        }
    }
    clone({ scripts = this.scripts, attributes = this.attributes, inputs = this.inputs, outputs = this.outputs, }) {
        return new this.constructor({
            version: this.version,
            attributes,
            inputs,
            outputs,
            scripts,
            gas: this.gas,
            script: this.script,
        });
    }
    serializeExclusiveBase(writer) {
        writer.writeVarBytesLE(this.script);
        if (this.version >= 1) {
            writer.writeFixed8(this.gas);
        }
    }
    async getScriptHashesForVerifying({ getOutput, getAsset, }) {
        const [inputHashes, outputHashes] = await Promise.all([
            Promise.all(this.inputs.map(async (input) => {
                const output = await getOutput({ hash: common.uInt256ToHex(input.hash), index: input.index });
                return addressToScriptHash(output.address);
            })),
            Promise.all(this.outputs.map(async (output) => {
                const assetHash = common.uInt256ToHex(output.asset);
                if (assetHash === common.NEO_ASSET_HASH || assetHash === common.GAS_ASSET_HASH) {
                    return undefined;
                }
                const asset = await getAsset(assetHash);
                if (asset.type === 'Duty') {
                    return common.uInt160ToHex(output.address);
                }
                return undefined;
            })).then((hashes) => hashes.filter(commonUtils.notNull)),
        ]);
        const attributeHashes = this.attributes
            .map((attribute) => attribute instanceof UInt160AttributeModel && attribute.usage === AttributeUsageModel.Script
            ? common.uInt160ToHex(attribute.value)
            : undefined)
            .filter(commonUtils.notNull);
        return [...inputHashes, ...outputHashes, ...attributeHashes];
    }
}
InvocationTransactionModel.VERSION = 1;

//# sourceMappingURL=InvocationTransactionModel.js.map
